"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertSmtpSettingsCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dmsbasereact = require("dmsbasereact");
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AlertSmtpSettingsCard = _ref => {
  let {
    title,
    description,
    showTestConnection = true,
    showConfiguredNote = true,
    onToggle,
    onTestConnection,
    elevation = 0,
    variant = "outlined"
  } = _ref;
  const [loading, setLoading] = (0, _react.useState)(true);
  const [saving, setSaving] = (0, _react.useState)(false);
  const [testing, setTesting] = (0, _react.useState)(false);
  const [debugMode, setDebugMode] = (0, _react.useState)(false);
  const [configured, setConfigured] = (0, _react.useState)(false);
  const [testResult, setTestResult] = (0, _react.useState)(null);
  const fetchDebugMode = (0, _react.useCallback)(async () => {
    setLoading(true);
    try {
      var _response$data;
      const response = await (0, _dmsbasereact.fetchData)("/alert_smtp_settings/debug-mode", "GET", true);
      const data = (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || (response === null || response === void 0 ? void 0 : response.data) || {};
      setDebugMode(data.debug_mode || false);
      setConfigured(data.configured || false);
    } catch (error) {
      _dmsbasereact.Notifications.toast(_dmsbasereact.intl.get("AlertSmtpSettings.FetchError").d("Failed to load settings"), "error");
    } finally {
      setLoading(false);
    }
  }, []);
  (0, _react.useEffect)(() => {
    fetchDebugMode();
  }, [fetchDebugMode]);
  const handleToggle = async () => {
    const newValue = !debugMode;
    setSaving(true);
    try {
      var _response$data2;
      const response = await (0, _dmsbasereact.fetchData)("/alert_smtp_settings/debug-mode", "PUT", true, {
        debug_mode: newValue
      });
      const data = (response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.data) || (response === null || response === void 0 ? void 0 : response.data) || {};
      if (data.success || response.status === _dmsbasereact.HTTP_STATUS.OK_200) {
        setDebugMode(newValue);
        _dmsbasereact.Notifications.toast(newValue ? _dmsbasereact.intl.get("AlertSmtpSettings.DebugEnabled").d("Alert email debug enabled") : _dmsbasereact.intl.get("AlertSmtpSettings.DebugDisabled").d("Alert email debug disabled"), "success");
        if (onToggle) {
          onToggle(newValue);
        }
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      _dmsbasereact.Notifications.toast(_dmsbasereact.intl.get("AlertSmtpSettings.UpdateError").d("Failed to update debug mode"), "error");
    } finally {
      setSaving(false);
    }
  };
  const handleTestConnection = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      var _response$data3;
      const response = await (0, _dmsbasereact.fetchData)("/alert_smtp_settings/test", "POST", true);
      const data = (response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.data) || (response === null || response === void 0 ? void 0 : response.data) || {};
      setTestResult({
        success: data.connection_ok,
        message: data.message
      });
      if (data.connection_ok) {
        _dmsbasereact.Notifications.toast(_dmsbasereact.intl.get("AlertSmtpSettings.TestSuccess").d("Connection successful"), "success");
      } else {
        _dmsbasereact.Notifications.toast(data.message || _dmsbasereact.intl.get("AlertSmtpSettings.TestFailed").d("Connection failed"), "error");
      }
      if (onTestConnection) {
        onTestConnection(data);
      }
    } catch (error) {
      setTestResult({
        success: false,
        message: _dmsbasereact.intl.get("AlertSmtpSettings.TestError").d("Error testing connection")
      });
      _dmsbasereact.Notifications.toast(_dmsbasereact.intl.get("AlertSmtpSettings.TestError").d("Error testing connection"), "error");
    } finally {
      setTesting(false);
    }
  };
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_material.Card, {
      variant: variant,
      elevation: elevation,
      sx: {
        height: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        display: "flex",
        justifyContent: "center",
        p: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null))));
  }
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    variant: variant,
    elevation: elevation,
    sx: {
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      mb: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.NotificationsActive, {
    sx: {
      mr: 1,
      color: "secondary.main"
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle1",
    fontWeight: "bold"
  }, title || _dmsbasereact.intl.get("AlertSmtpSettings.Title").d("Alert System Emails Debug")), configured && /*#__PURE__*/_react.default.createElement(_material.Chip, {
    label: _dmsbasereact.intl.get("AlertSmtpSettings.Configured").d("Configured"),
    size: "small",
    color: "success",
    sx: {
      ml: "auto"
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      mb: 2
    }
  }, description || _dmsbasereact.intl.get("AlertSmtpSettings.Description").d("Debug mode for alert system emails (notifications, expiration alerts, campaigns).")), /*#__PURE__*/_react.default.createElement(_material.Divider, {
    sx: {
      my: 2
    }
  }), /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Switch, {
      checked: debugMode,
      onChange: handleToggle,
      disabled: saving,
      color: "warning"
    }),
    label: /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, debugMode ? _dmsbasereact.intl.get("AlertSmtpSettings.StatusEnabled").d("Alerts printed to console") : _dmsbasereact.intl.get("AlertSmtpSettings.StatusDisabled").d("Alerts sent by email"))
  }), showConfiguredNote && !configured && /*#__PURE__*/_react.default.createElement(_material.Alert, {
    severity: "info",
    sx: {
      mt: 2
    }
  }, _dmsbasereact.intl.get("AlertSmtpSettings.NotConfiguredNote").d("Note: Alert SMTP is not configured. Configure it in the Communication tab to send emails.")), showTestConnection && configured && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      mt: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "outlined",
    size: "small",
    onClick: handleTestConnection,
    disabled: testing,
    startIcon: testing ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      size: 16
    }) : null
  }, testing ? _dmsbasereact.intl.get("AlertSmtpSettings.Testing").d("Testing...") : _dmsbasereact.intl.get("AlertSmtpSettings.TestConnection").d("Test Connection")), testResult && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      mt: 1,
      gap: 1
    }
  }, testResult.success ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.CheckCircle, {
    color: "success",
    fontSize: "small"
  }) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.Error, {
    color: "error",
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "caption",
    color: testResult.success ? "success.main" : "error.main"
  }, testResult.message)))));
};
exports.AlertSmtpSettingsCard = AlertSmtpSettingsCard;
AlertSmtpSettingsCard.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  showTestConnection: _propTypes.default.bool,
  showConfiguredNote: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  onTestConnection: _propTypes.default.func,
  elevation: _propTypes.default.number,
  variant: _propTypes.default.oneOf(["elevation", "outlined"])
};